import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig } from '@intelliarts/ia-react-template';

import authConfig, { IA_PEOPLE_MENU_GROUP } from '../../../config/authConfig';
import { BenchHistoryStore } from '../store/benchHistoryStore';
import { ChangeReasonsStore, StatusHistoryDialogChangeReasonsStore } from '../../Employee/store/changeReasonsStore';
import { BENCH_PAGE_LOCALE_PATH } from '../../Employee/locales';

export const BenchRoutes = {
  default: 'bench',
};

export const BenchPageConfig: ReactPageConfig = {
  name: `${BENCH_PAGE_LOCALE_PATH}.pageConfig.name`,
  path: BenchRoutes.default,
  allowedRoles: [authConfig.roles.ADMIN],
  component: lazy(() => import('../components/BenchPage')),
  storeDependencies: [
    { store: BenchHistoryStore },
    { store: ChangeReasonsStore },
    { store: StatusHistoryDialogChangeReasonsStore },
  ],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/EventSeat')),
    label: `${BENCH_PAGE_LOCALE_PATH}.pageConfig.label`,
    group: IA_PEOPLE_MENU_GROUP,
    isCollapsibleGroup: true,
  }),
};
